/** Об'єднує лише одночасні читання; готові відповіді не кешуються. */
export class InflightReads {
  private pending = new Map<string, Promise<unknown>>();

  invalidate(): void {
    this.pending.clear();
  }

  get<T>(key: string, load: () => Promise<T>): Promise<T> {
    const existing = this.pending.get(key);
    if (existing) return existing as Promise<T>;
    const request = Promise.resolve()
      .then(load)
      .finally(() => {
        // Старий запит після invalidate не повинен прибрати новий.
        if (this.pending.get(key) === request) this.pending.delete(key);
      });
    this.pending.set(key, request);
    return request;
  }
}

export const reads = new InflightReads();
